__webpack_require__.p = "https://assets.canny.io/daaad90ab89797ebedc72c0d812cd159a9907923/";